<div class="bg_message"></div>
<div class="bottom_message" id="idea_filter">
  <div class="wrap">
    <div class="ttl">{{ 'Pages.OfferList.Search.HeaderText' | translate }}:</div>
    <div class="message">
      <div class="form_class">
        <div [ngClass]="[ offerKindId || offerKindId == '' ? 'ins_space top' : 'ins_space']">
          <div class="label">{{ 'Pages.OfferList.Search.Param0Text' | translate }} </div>
          <input type="text" style="display: none" />
          <select name="" [(ngModel)]="offerKindId" [ngModelOptions]="{standalone: true}">
            <option selected="selected" value="">Все</option>
            <option value="{{offerKind.value}}" *ngFor="let offerKind of offerKinds">{{offerKind.name}}</option>
          </select>
        </div>
        <div [ngClass]="[ statusId || statusId == '' ? 'ins_space top' : 'ins_space']">
          <div class="label">{{ 'Pages.OfferList.Search.Param1Text' | translate }} </div>
          <input type="text" style="display: none" />
          <select name="" [(ngModel)]="statusId" [ngModelOptions]="{standalone: true}">
            <option selected="selected" value="">Все</option>
            <option value="{{status.value}}" *ngFor="let status of statuses">{{status.name}}</option>
          </select>
        </div>
        <div class="ins_space top">
          <div class="label">{{ 'Pages.OfferList.Search.Param2Text' | translate }}</div>
          <input type="date" [(ngModel)]="dateStart" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="ins_space top">
          <div class="label">{{ 'Pages.OfferList.Search.Param3Text' | translate }}</div>
          <input type="date" [(ngModel)]="dateEnd" [ngModelOptions]="{standalone: true}">
        </div>
      </div>
    </div>
    <div class="button_block pos_l_r clrfx">
      <a class=" button small_radius w100 border_blue right" (click)="search()">{{ 'Pages.OfferList.Search.FindText' | translate }}</a>
      <a class=" button small_radius w100  left" (click)="clearSearch()">{{ 'Pages.OfferList.Search.ClearText' | translate }}</a>
    </div>
    <a class="close close_modal_ref" (click)="activeModal.close()"></a>
  </div>
</div>
